// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","cwSliderArrow":"sliderArrow-module__cwSliderArrow___cJ7Qz","cwSliderArrowActive":"sliderArrow-module__cwSliderArrowActive___3fi_I"};